import React from 'react';


const LockerDetailsComponent = ({ locker, variant = 'default', onBook }) => {
  // Default values if locker data is not provided
  const {
    name = "Storage Spot",
    address = "Address will be shown after booking",
    city = "",
    price = "₹30/hr",
    backgroundImage = "https://via.placeholder.com/400x200/2196f3/ffffff?text=Storage+Spot",
    logoImage = "",
    available = 0,
    distance = "",
    description = "",
    lockerNumber = ""
  } = locker || {};

  // Format price display
  const formatPrice = (priceStr) => {
    if (!priceStr) return "From $2.95 / day";
    return `From ${priceStr}`;
  };

  // Get location string
  const getLocation = () => {
    if (address && city) return `${address}, ${city}`;
    if (address) return address;
    if (city) return city;
    return "Location available after booking";
  };

  return (
    <div className="storage-card">
      {/* Image Section */}
      <div className="image-container">
        <img 
          src={backgroundImage}
          alt={name}
          className="image"
          onError={(e) => {
            e.target.src = "https://via.placeholder.com/400x200/2196f3/ffffff?text=Storage+Spot";
          }}
        />

      </div>

      {/* Content Section */}
      <div className="content">
        <div className="header">
          <h2 className="title">{name}</h2>
          
          <div className="badge-container">
            <span className="badge badge-open">Open 24h</span>
            {distance && (
              <span className="badge badge-distance">{distance} km</span>
            )}
          </div>
          
          <div className="info-line">
            <span className="everyday">Every day</span>
            {lockerNumber && (
              <span className="locker">Locker # {lockerNumber}</span>
            )}
          </div>
        </div>

        {description && (
          <div className="description">
            <p>{description}</p>
          </div>
        )}

        <div className="address-section">
          <p className="address-label">
            <span className="address-icon">📍</span>
            {getLocation()}
          </p>
          <div className="divider"></div>
        </div>

        <div className="hours">
          <h3 className="subtitle">Opening hours</h3>
          <p className="hours-text">Open 24 hours · Every day</p>
        </div>

        <div className="includes">
          <h3 className="subtitle">Your online booking includes</h3>
          
          <div className="feature">
            <span className="feature-icon">✓</span>
            <div className="feature-content">
              <strong>Free cancellation</strong>
              <p>Cancel anytime before drop off for a refund.</p>
            </div>
          </div>

          <div className="feature">
            <span className="feature-icon">🛡️</span>
            <div className="feature-content">
              <strong>Bag protection</strong>
              <p>Peace of mind knowing you've got $10,000 coverage for each bag.</p>
            </div>
          </div>

          <div className="feature">
            <span className="feature-icon">💬</span>
            <div className="feature-content">
              <strong>24/7 support</strong>
              <p>Dedicated support team ready to assist you. We typically reply in 15 minutes.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer with Price and Button */}
      <div className="footer">
        <div className="price-section">
          <div className="price">
            {formatPrice(price)}/24 hours
          </div>
          <button className="button" onClick={onBook}>
            Book this store
          </button>
        </div>
      </div>
    </div>
  );
};

export default LockerDetailsComponent;